<template>
  <div
    v-show="isVisible"
    class="custom-loader"
    :class="{
      'is-centered': isCentered,
      'has-padding': hasPadding,
      'is-absolute': isAbsolute
    }"
  >
    <span :style="{ fontSize: `${size}em` }" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Loading",
  props: {
    size: { type: Number, default: 3 },
    delay: { type: Number, default: 3 },
    isAbsolute: { type: Boolean, default: false },
    isCentered: { type: Boolean, default: true },
    hasPadding: { type: Boolean, default: true }
  },
  data: () => ({
    isVisible: false
  }),
  created() {
    setTimeout(() => {
      this.isVisible = true;
    }, this.delay);
  }
});
</script>

<style lang="scss" scoped>
@mixin is-absolute() {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-loader {
  &.is-centered {
    text-align: center;
    margin: auto;
  }

  &.is-absolute {
    @include is-absolute();
  }
  &.is-absolute-tablet {
    @include tablet {
      @include is-absolute();
    }
  }
  &.is-absolute-desktop {
    @include desktop {
      @include is-absolute();
    }
  }
  &.is-absolute-widescreen {
    @include widescreen {
      @include is-absolute();
    }
  }
  &.is-absolute-fullhd {
    @include fullhd {
      @include is-absolute();
    }
  }

  & > span {
    display: inline-block;
    width: 1em;
    height: 1em;

    &:after {
      content: "";
      display: block;
      width: 1em;
      height: 1em;
      border-radius: 50%;
      border: 0.12em solid rgba(0, 0, 0, 0.15);
      border-top-color: $dark;
      border-top-color: var(--brand-color);
      animation: loading 0.666s linear infinite;
      box-sizing: border-box;
    }
  }

  &.has-padding > span {
    margin: 1.5rem;
  }
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
